import React, { Component } from 'react';
import {injectIntl, intlShape} from 'react-intl';
const LOCALE_PREFIX = 'DE/components/Footer/Footer';

// this Footer should be on the applypage, errorpage, and decisionpage for DE
export class DeMemberErrFooter extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
    };

    render() {
        const {intl} = this.props;
        return (
            <div id="de-paypal-footer" className="clearfix">
                <span className="pull-right">
                    <i className="Icon Icon_pp-ratenzahlung-logo" />
                </span>
            </div>
        );
    }
}

export default injectIntl(DeMemberErrFooter);
